import initCheckout, {processCheckoutReturn} from "./pages/paiement";
window.initCheckout = initCheckout;
window.processCheckoutReturn = processCheckoutReturn;